import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule} from 'app/app.module';
import { environment } from './environments/environment';
import { browserTracingIntegration } from '@sentry/angular';
import * as Sentry from '@sentry/angular';

Sentry.init({
  dsn: 'https://e45426fc49904af6b7a1ebd906026c71@o1423690.ingest.sentry.io/6771409',
  integrations: [browserTracingIntegration()],
  tracePropagationTargets: ['frontend', environment.apiUrl],
  tracesSampleRate: 1,
  beforeSend(event) {
    const isApiError: boolean = event.exception?.values?.some(exception => {
      return exception.stacktrace?.frames?.some(frame => frame?.filename?.includes(environment.apiUrl));
    });
    const hasUserTestEmail: boolean = ['@intelis.ai', 'test1.com'].includes(event?.user?.email);

    if (hasUserTestEmail || !isApiError) return null;
    return event;
  },
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
